import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  ProcessingQueueLookupRequest,
  ProcessingQueueLookupResponse
} from '../models/processing-queue.models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProcessingQueueService {
  constructor(private api: ApiService) {}
  private baseUrl = environment.apiUrl;

  lookup(request: ProcessingQueueLookupRequest): Observable<ProcessingQueueLookupResponse> {
    return this.api.post<ProcessingQueueLookupResponse>(
      `${this.baseUrl}/ProcessingQueue/Lookup`,
      {
        Page: request.Page,
        PageSize: request.PageSize,
        SearchText: request.SearchText,
        ShowErrorsOnly: request.ShowErrorsOnly,
        ShowProducts: request.ShowProducts,
        ShowVariants: request.ShowVariants,
        ShowGlobalListValues: request.ShowGlobalListValues
      }
    );
  }
}